export default "__VITE_ASSET__DDz5XGo2__"